export const skeleton = {
  root: ({ props }: Record<string, any>) => ({
    class: [
      'overflow-hidden',
      {
        'animate-pulse': props.animation !== 'none',
      },
      // Round
      { 'rounded-full': props.shape === 'circle', 'rounded-md': props.shape !== 'circle' },
      // Colors
      'bg-grey-400/25',
    ],
  }),
};
